import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import { BigFilingWeek } from '../../../../components/S/big-filing-days/bigFilingWeek';
import { b2cData } from '../../../../components/cms/layout/components/header';
import { WEB_SCHEMA } from '../../../../constants/componentStaticData';
import { Meta } from '../../../../layout/Meta';
import { FM_ACTIONS, returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';
import { handleTrack } from '../../../../utils/tracker';

const ITR2 = (): JSX.Element => {
  useEffect(() => {
    if (window !== undefined) {
      window.parentCategory = 'big_filing';
      handleTrack({
        label: window.location.pathname,
        action: FM_ACTIONS.pageview,
      });
    }
  }, []);
  const title =
    'Big Filing Days: File your ITR on ClearTax and win exciting rewards';
  const desc = `Big Filing Days: India's biggest tax filing festival brought to you by ClearTax. File your Income Tax Returns (ITR) on ClearTax and win exciting rewards, unlock exclusive benefits and expert assistance.`;

  return (
    <div className="relative">
      <ClearInNavbar data={b2cData} showPlanVariant={'variantA'} />
      <BigFilingWeek></BigFilingWeek>
      <Meta
        title={title}
        description={desc}
        canonical={'/s/big-filing-days'}
        keywords={
          'big filing days, cleartax, cleartax big filing days, tax filing festival, cleartax offers, cleartax discounts, cleartax rewards, income tax e filing, income tax filing, cleartax itr filing'
        }
        isItr={true}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            WEB_SCHEMA({
              title: title,
              metaDesc: desc,
              url: '/s/big-filing/days',
            })
          ),
        }}
      ></script>
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default ITR2;
